export const shadows = {
  modal: '0 0 8px -2px rgba(0, 0, 0, 0.1), 0 6px 20px -3px rgba(0, 0, 0, 0.2)',
  card: '0 1.5px 8px 0 rgba(24, 32, 63, 0.13), 0 1px 2px 0 rgba(24, 32, 63, 0.07)',
} as const;
